'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import scriptLoader from 'react-async-script-loader';

const DEFAULT_ZOOM_LEVEL = 12;

class EventCenterMap extends React.Component {
  static propTypes = {
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    changeCenter: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.map = null;
  }

  mapOptions() {
    return {};
  }

  componentWillReceiveProps({ isScriptLoaded, isScriptLoadSucceed }) {
    if (isScriptLoaded && !this.props.isScriptLoaded) { // load finished
      if (isScriptLoadSucceed) {
        this.renderMap();
      }
    }
  }

  marker() {
    const latLng = new google.maps.LatLng(this.props.lat, this.props.lng);
    return new google.maps.Marker({
      position: latLng,
      draggable: true,
    });
  }

  handleMarkerDrag = (ev) => {
    if (ev) {
      const value = { lat: ev.latLng.lat(), lng: ev.latLng.lng() };
      this.props.changeCenter(value);
    }
  }

  renderMap() {
    this.map = new google.maps.Map(this.refs.map, this.mapOptions());
    const center = new google.maps.LatLng(this.props.lat, this.props.lng);
    this.map.setCenter(center);
    this.map.setZoom(DEFAULT_ZOOM_LEVEL);
    const marker = this.marker();
    marker.addListener('dragend', this.handleMarkerDrag);
    marker.setMap(this.map);
  }

  render() {
    return (
      <div>
        <div ref="map" style={{ height: '550px', width: '100%' }} />
      </div>
    );
  }
}

export default scriptLoader(
  'https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyADBKpy4vE0dXNCiqCLAUO2UcgD3qiEGrA'
)(EventCenterMap);
